<template>
  <a
    :href="route('home')"
    class="logotype"
    :class="{ 'logotype--large': large, 'logotype--white': white }"
  >
    <img :style="'width: ' + width + ';height: ' + height" :src="src" alt="KERP" class="logotype__image" />
    <div class="logotype__header" v-if="title || subTitle">
      <span class="logotype__title" v-if="title">{{ title }}</span>
      <small class="logotype__subtitle" v-if="subTitle">{{ subTitle }}</small>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    dataLarge: {
      type: Boolean,
      required: false
    },
    dataWhite: {
      type: Boolean,
      required: false
    },
    src: {
      type: String,
      required: false,
      default: "/images/mybill-isotype.png"
    },
    title: {
      type: String,
      required: false,
      default: "MyBill"
    },
    subTitle: {
      type: String,
      required: false,
      default: "Sistema de facturación en línea"
    },
    width: {
      required: false,
      default: ''
    },
    height: {
      required: false,
      default: ''
    }
  },
  data() {
    return {
      large: this.dataLarge,
      white: this.dataWhite
    };
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/layout/Logo.vue